import React, { useEffect } from 'react';
import { Col, Container, ListGroup, Card } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { getWords } from '../../utils/reusableFunctions';
import styles from '../../css/icons.module.css';
import { useSelector } from 'react-redux';
import {
  SelectFlattenedIncidentsByDateRange,
  primarySelector,
  useLazyGetIncidentsQuery,
} from '../../features/incidents/incidents.api';
import { Loader } from '../../components/common';
import { Link } from 'react-router-dom';
import { Routes } from '../../config';

const IncidentList = ({ len }) => {
  const [getIncidents] = useLazyGetIncidentsQuery();
  const filteredIncidents = useSelector(SelectFlattenedIncidentsByDateRange);
  const { isSuccess } = useSelector(primarySelector);
  const incidentList = len
    ? filteredIncidents.slice(0, len)
    : filteredIncidents.slice(0, 3);

  useEffect(() => {
    if (filteredIncidents.length === 0) getIncidents();
  }, [filteredIncidents.length, getIncidents]);

  const Incident = (props) => {
    const { title, description, id } = props;

    return (
      <ListGroup.Item className='px-0'>
        <Container>
          <Col className='col-auto'>
            <h4 className='h6 mb-0 text-primary'>
              <FontAwesomeIcon
                icon={faShieldAlt}
                className='me-2 text-secondary'
              />
              <Link to={`${Routes.Incidents.path}/${id}`}>{title}</Link>
            </h4>
            <small className='text-black'>
              {getWords({ str: description })}...
            </small>
            <br></br>
            <small className='mb-0 text-black'>
              Explore
              <Card.Link
                as={Link}
                to={`${Routes.Incidents.path}/${id}`}
              >
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className={`ms-2 me-2 text-black ${styles.longIcon}`}
                  size='xs'
                />
              </Card.Link>
            </small>
          </Col>
        </Container>
      </ListGroup.Item>
    );
  };

  return (
    <Loader loaded={isSuccess}>
      <Card
        border='light'
        className='shadow-sm'
      >
        <Card.Header className='border-bottom d-flex justify-content-between bg-secondary text-black'>
          <h4 className='h6 mb-0'>Recent Incidents</h4>
        </Card.Header>
        <Card.Body>
          <ListGroup className='list-group-flush list my--3'>
            {incidentList.map((i) => (
              <Incident
                key={i.id}
                {...i}
              />
            ))}
          </ListGroup>
        </Card.Body>
      </Card>
    </Loader>
  );
};

export default IncidentList;
